import { Controller } from '@hotwired/stimulus'
import zoid from 'zoid9031'

/**
 * This controller is used in
 * - views/claims/modal/show.html.erb
 * - provenance/app/components/proof_point_component.html.erb
 * It's used for backwards compatibility
 */
export default class extends Controller {
  static get targets () {
    return ['journey']
  }

  connect () {
    if (window.self === window.top) {
      // We are not in an iframe
      return
    }

    // SDK < v0.8 didn't have xprops.version, therefore
    // if a version is present, it's not a legacy SDK version
    // and this controller isn't needed for embed modals to work.
    // Return early so that the code below won't run.
    if (window.xprops && window.xprops.version) return

    console.debug('[embed_modal_controller] connected.')

    // slug cannot be used since it actually doesn't match the one in window.location.href
    // const tag = this.element.dataset.slug.toLowerCase()

    const height = this.hasJourneyTarget ? '100%' : '482px'

    const zoidTag = getEmbedSlug(window.location.href, this.element)

    window.ProvenanceEmbedModal = zoid.create({
      tag: zoidTag,
      url: window.location.href,
      dimensions: {
        width: '100%',
        height
      },
      autoResize: {
        height: true,
        width: false
      }
    })

    console.debug('embed_modal_controller created frame with tag', zoidTag, 'for location.href = ', window.location.href)

    if (window.xprops && window.xprops.loaded) {
      window.xprops.loaded() // This seems to be used only in Platform lib.
    }
  }
}

/* Returns a slug that is valid for use as zoid tag.
 * A zoid tag must match this regex: /^([a-z0-9][a-z0-9-]*)+[a-z0-9]+$/
 */
function getEmbedSlug (url, el) {
  if (el.dataset.slug) return el.dataset.slug.toLowerCase()

  return new URL(url).pathname.split('/')[2].toLowerCase()
}
